import {
  DATA_CONNECTOR_REFRESH_SOURCE_DATA_BEGIN,
  DATA_CONNECTOR_REFRESH_SOURCE_DATA_SUCCESS,
  DATA_CONNECTOR_REFRESH_SOURCE_DATA_FAILURE,
  DATA_CONNECTOR_REFRESH_SOURCE_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function refreshSourceData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_REFRESH_SOURCE_DATA_BEGIN,
    });

    const { projectId, sourceUuid, connectorUuid, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/data-connector/sync-records`;
      const data = { sourceUuid, connectorUuid };
      const doRequest = axios.post(url, data, header);
      doRequest.then(
        (res) => {
          console.log('res', res);
          const { data } = res;
          if (data.success) {
            dispatch({
              type: DATA_CONNECTOR_REFRESH_SOURCE_DATA_SUCCESS,
              data,
            });
            toast.error(`Data will be sync shortly`, {});
            resolve(data);
          } else {
            dispatch({
              type: DATA_CONNECTOR_REFRESH_SOURCE_DATA_FAILURE,
              data: data.message,
            });
            toast.error(`Refreshing Records Failed: ${data.message}`, {});
            reject(error);
          }
        },
        (err) => {
          console.log('err', err.response.data);
          let error = '';
          if (err.response.data) {
            error = err.response.data.message;
          }
          dispatch({
            type: DATA_CONNECTOR_REFRESH_SOURCE_DATA_FAILURE,
            data: { error },
          });
          toast.error(`Refreshing Records Failed: ${error}`, {});
          reject(error);
        },
      );
    });

    return promise;
  };
}

export function dismissRefreshSourceDataError() {
  return {
    type: DATA_CONNECTOR_REFRESH_SOURCE_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_REFRESH_SOURCE_DATA_BEGIN:
      return {
        ...state,
        refreshSourceDataPending: true,
        refreshSourceDataError: null,
      };

    case DATA_CONNECTOR_REFRESH_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        refreshSourceDataPending: false,
        refreshSourceDataError: null,
      };

    case DATA_CONNECTOR_REFRESH_SOURCE_DATA_FAILURE:
      return {
        ...state,
        refreshSourceDataPending: false,
        refreshSourceDataError: action.data.error,
      };

    case DATA_CONNECTOR_REFRESH_SOURCE_DATA_DISMISS_ERROR:
      return {
        ...state,
        refreshSourceDataError: null,
      };

    default:
      return state;
  }
}
